module.exports = __webpack_public_path__ + "img/fifth_tree.10b58ad0.png";